import React from 'react'
import { InputText } from 'primereact/inputtext'
import { classNames } from 'primereact/utils'
import { Tag } from 'primereact/tag'
import { FormattedMessage } from 'react-intl'
import DeleteButton from '../../components/common/buttons/DeleteButton'
import './dataTableFun.scss'
import DuplicateButton from '../../components/common/buttons/DuplicateButton'

// TODO: mover a common a data-table
export const DataTableFun = {
  onCellEditComplete: (e) => {
    const { rowData, newValue, field, originalEvent: event } = e
    if (newValue !== null) rowData[field] = newValue
    else event.preventDefault()
  },
  textEditor: (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={({ target: { value } }) => options.editorCallback(value)}
      />
    )
  },
  isCheckCircleBodyTemplate: (check) => {
    return (
      <i className={classNames('pi', { 'true-icon pi-check-circle': check })} />
    )
  },
  buttonDelete: (rowData, handleDelete) => (
    <div key={rowData?._id}>
      <DeleteButton onClick={() => handleDelete(rowData?._id)} />
    </div>
  ),
  buttonDuplicate: (rowData, handleDuplicate) => (
    <div key={rowData?._id}>
      <DuplicateButton onClick={() => handleDuplicate(rowData?._id)} />
    </div>
  ),
  getSeverity: (value) => {
    // 'pending', 'sent', 'failed', 'validated'
    switch (value) {
      case 'pending':
        return 'warning'
      case 'sent':
        return 'primary'
      case 'failed':
        return 'danger'
      case 'validated':
        return 'success'
      default:
        return 'info'
    }
  },
  statusNotificationPricesTemplate: (rowData) => {
    const val = rowData?.status && <FormattedMessage id={rowData?.status} />
    const error = rowData?.send?.web?.error
    return (
      <div className="status-tag-with-tooltip">
        {error && <span className="tooltiptext">{error}</span>}
        <Tag value={val} severity={DataTableFun.getSeverity(rowData?.status)} />
      </div>
    )
  },

  responsiveHeight: (paddingBottom = 0) => {
    // eslint-disable-next-line no-nested-ternary
    // console.log('DataTableFun.responsiveHeight', paddingBottom)
    let bottomOffset = 0
    if (window.innerWidth > 992) {
      bottomOffset = 320
    } else if (window.innerWidth > 768) {
      bottomOffset = 340
    } else if (window.innerWidth > 576) {
      bottomOffset = 340
    } else {
      bottomOffset = 460
    }
    return (
      window.innerHeight + window.scrollY + paddingBottom - bottomOffset + 'px'
    )
  },

  responsiveResize: (paddingBottom = 0) => {
    // Limit to current datatable (by id/name)???
    // console.log('DataTableFun.responsiveResize', paddingBottom)
    document.querySelectorAll('.p-datatable-wrapper').forEach((dt) => {
      dt.style['max-height'] = DataTableFun.responsiveHeight(paddingBottom)
      dt.style.height = DataTableFun.responsiveHeight(paddingBottom)
    })
    document.querySelectorAll('.p-datatable-body').forEach((dt) => {
      dt.style['max-height'] = DataTableFun.responsiveHeight(paddingBottom)
      dt.style.height = DataTableFun.responsiveHeight(paddingBottom)
    })
  },
}
